import localforage from 'localforage';
import {
  UserManager,
  WebStorageStateStore,
  AsyncStorage,
} from 'oidc-client-ts';

const localforageStore: AsyncStorage = {
  get length() {
    return localforage.length();
  },
  clear: () => localforage.clear(),
  getItem: (key) => localforage.getItem<string>(key),
  key: (index) => localforage.key(index),
  removeItem: (key) => localforage.removeItem(key),
  setItem: (key, value) => localforage.setItem(key, value).then(() => {}),
};

export const oidcSettings = {
  authority: import.meta.env.VITE_APP_AUTHORITY,
  client_id: import.meta.env.VITE_APP_CLIENT_ID,
  redirect_uri: import.meta.env.VITE_APP_REDIRECT_URI,
  response_type: 'code',
  scope: import.meta.env.VITE_APP_SCOPE,
  userStore: new WebStorageStateStore({ store: localforageStore }),
  post_logout_redirect_uri: import.meta.env.VITE_APP_POST_LOGOUT_REDIRECT_URI,
  silent_redirect_uri: import.meta.env.VITE_APP_SILENT_RENEW_URI,
  automaticSilentRenew: true,
  filterProtocolClaims: true,
  loadUserInfo: true,
};

const userManager = new UserManager(oidcSettings);

userManager.startSilentRenew();

userManager.events.addSilentRenewError(async () => {
  try {
    const user = await userManager.getUser();
    if (user) {
      window.location.assign('/signout');
    }
  } catch (error) {
    console.error('Error handling silent renew failure:', error);
  }
});

export default userManager;
